const IconAc = () => {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5878_125327)">
                <path
                    d="M23 14.3359H9C8.44772 14.3359 8 14.7837 8 15.3359V18.3359H24V15.3359C24 14.7837 23.5523 14.3359 23 14.3359Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M27.5 6.33594H4.5C3.67157 6.33594 3 7.00751 3 7.83594V16.8359C3 17.6644 3.67157 18.3359 4.5 18.3359H27.5C28.3284 18.3359 29 17.6644 29 16.8359V7.83594C29 7.00751 28.3284 6.33594 27.5 6.33594Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M21 9.33594H23.6667" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M10.9 20.3359L10.0982 21.4814C9.7522 21.9757 9.81098 22.6469 10.2376 23.0735V23.0735C10.675 23.511 10.7243 24.2036 10.353 24.6985L9.5 25.8359"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M16.4 20.3359L15.5982 21.4814C15.2522 21.9757 15.311 22.6469 15.7376 23.0735V23.0735C16.175 23.511 16.2243 24.2036 15.853 24.6985L15 25.8359"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M21.9 20.3359L21.0982 21.4814C20.7522 21.9757 20.811 22.6469 21.2376 23.0735V23.0735C21.675 23.511 21.7243 24.2036 21.353 24.6985L20.5 25.8359"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_5878_125327">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.335449)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconAc;
